import * as React from "react";
import * as _ from "lodash";

import { StyledBoxChip, StyledBoxDisplay, Title } from "./style";

export default function CustomChip({
  title,
  background,
  color,
  isIcon,
  icon,
  padding,
  fontSize,
}) {
  return (
    <StyledBoxChip background={background} padding={padding}>
      <StyledBoxDisplay>
        {isIcon && (
          <img loading="lazy" width={8} height={8} src={icon} alt="rectangle" />
        )}
        <Title fontSize={fontSize} iscolor={color}>
          {_.capitalize(title)}
        </Title>
      </StyledBoxDisplay>
    </StyledBoxChip>
  );
}
